// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"691":"e2f02cd1","1318":"45b6010b","5279":"285aa7c3","6643":"8385d5d6","8700":"49d3607d"}[chunkId] + ".chunk.css";
};